/** @format */

import React, { useState } from 'react'
import { _$, Card, Tabs, Tab, Icon } from '@king-design/react'
import styled from 'styled-components'
import { useLocation, useHistory } from 'react-router'
import MonitorCrumb from 'src/components/MonitorCrumb'
import HeaderFilter from '../../components/HeaderFilter'
import { initSearch } from '../../components/constant'
import { ServiceOverviewSearchProps } from '../../components/typescript'
import Overview from '../container/Overview'
import ChartRow from '../container/ChartRow'
import SessionContainer from '../../SessionAnalysis/container'
import TraceContainer from '../../TraceAnalysis/container'
import { replaceSearchParams } from 'src/utils'
function useQuery() {
  return new URLSearchParams(useLocation().search)
}

type TabType = 'overview' | 'session' | 'trace'
// 嵌入页面隐藏面包屑
const IS_TOP_WINDOW: boolean = window.self === window.top

const ServiceOverview: React.FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const location = useLocation()
  const serviceName = query.get('serviceName')
  const query_tab = query.get('tab') || 'overview'
  const [filterSearch, setFilterSearch] = useState<ServiceOverviewSearchProps>(initSearch())
  // 服务Tab
  const [tab, setTab] = useState<TabType>(query_tab as TabType)
  return (
    <div className={className}>
      {IS_TOP_WINDOW ? (
        <MonitorCrumb
          breadArr={[
            { title: _$('AI可观测') },
            { title: _$('服务总览'), route: '/monitor/aiobservability/serviceoverview' },
            { title: _$('服务详情') }
          ]}
        />
      ) : null}
      <Card
        slotTitle={
          IS_TOP_WINDOW ? (
            <div className="k-card-title-back" onClick={() => history.goBack()}>
              <Icon className="ion-ios-arrow-back" />
              <span>{serviceName}</span>
            </div>
          ) : null
        }
      >
        <HeaderFilter value={filterSearch} onChange={setFilterSearch} />
        <Tabs
          type="flat-card"
          className="service-detail-tabs"
          value={tab}
          onChangeValue={v => {
            setTab(v as TabType)
            replaceSearchParams(history, location, {
              tab: v
            })
          }}
        >
          <Tab value="overview">{_$('运行时总览')}</Tab>
          <Tab value="session">{_$('会话分析')}</Tab>
          <Tab value="trace">{_$('Trace分析')}</Tab>
        </Tabs>
        {tab === 'overview' ? (
          <>
            <Overview
              serviceName={serviceName}
              startTime={filterSearch.time[0]}
              endTime={filterSearch.time[1]}
            />
            <ChartRow
              serviceName={serviceName}
              startTime={filterSearch.time[0]}
              endTime={filterSearch.time[1]}
              aggregate={filterSearch.aggregateType}
            />
          </>
        ) : null}
        {tab === 'session' ? (
          <SessionContainer headerSearch={filterSearch} serviceName={serviceName} />
        ) : null}
        {tab === 'trace' ? (
          <TraceContainer headerSearch={filterSearch} serviceName={serviceName} />
        ) : null}
      </Card>
    </div>
  )
}

export default styled(ServiceOverview)`
  padding: 16px;
  .service-detail-tabs {
    margin-top: 16px;
  }
`
